<div class="edit-product-page" dir="rtl">
  <div class="page-header">
    <div>
      <h1>تحديث المنتج</h1>
      <p>قم بتعديل بيانات المنتج، الأسعار، المخزون، والتصنيفات.</p>
    </div>

    <div class="header-actions">
      <button type="button" class="btn ghost" (click)="onCancel()">رجوع</button>

      <button type="button" class="btn light" (click)="onReset()" [disabled]="isLoading || isSaving">
        إعادة تحميل
      </button>
    </div>
  </div>

  <div *ngIf="isLoading" class="state-card">
    جاري تحميل البيانات...
  </div>

  <div *ngIf="errorMessage" class="alert alert-error">
    {{ errorMessage }}
  </div>

  <form *ngIf="!isLoading" [formGroup]="productForm" class="product-card" novalidate>
    <div class="tabs">
      <button type="button" *ngFor="let tab of tabs" [class.active]="activeTab === tab.key"
        (click)="setActiveTab(tab.key)">
        <span>{{ tab.labelAr }}</span>
        <small>{{ tab.labelEn }}</small>
      </button>
    </div>

    <!-- BASIC -->
    <section *ngIf="activeTab === 'basic'" class="tab-body">
      <div class="section-title">
        <h2>البيانات الأساسية</h2>
        <p>اختيار التصنيف، البراند، وبيانات الاسم والوصف.</p>
      </div>

      <div class="grid two">
        <div class="form-group">
          <label>نوع التصنيف *</label>

          <select formControlName="sourceType">
            <option *ngFor="let source of sources" [ngValue]="source.id">
              {{ source.name }}
            </option>
          </select>
        </div>

        <div class="form-group" [class.invalid]="isDropdownInvalid('mainCategoryId')">
          <label>الفئة الرئيسية *</label>

          <ng-multiselect-dropdown [placeholder]="'اختر الفئة الرئيسية'" [settings]="singleDropdownSettings"
            [data]="mainCategories" [formControl]="mainCategoryControl">
          </ng-multiselect-dropdown>

          <small class="error" *ngIf="isDropdownInvalid('mainCategoryId')">
            الفئة الرئيسية مطلوبة
          </small>
        </div>
      </div>

      <div class="grid two">
        <div class="form-group">
          <label>الفئات الفرعية</label>

          <ng-multiselect-dropdown [placeholder]="'اختر الفئات الفرعية'" [settings]="multiDropdownSettings"
            [data]="subCategories" [formControl]="subCategoryControl">
          </ng-multiselect-dropdown>

          <small class="hint">يمكن اختيار أكثر من فئة فرعية.</small>
        </div>

        <div class="form-group" [class.invalid]="isDropdownInvalid('brandId')">
          <label>البراند *</label>

          <ng-multiselect-dropdown [placeholder]="'اختر البراند'" [settings]="singleDropdownSettings" [data]="brands"
            [formControl]="brandControl">
          </ng-multiselect-dropdown>

          <small class="error" *ngIf="isDropdownInvalid('brandId')">
            البراند مطلوب
          </small>
        </div>
      </div>

      <div class="grid three">
        <div class="form-group">
          <label>Parent ID</label>
          <input type="number" readOnly formControlName="parentId" placeholder="اختياري" />
        </div>

        <div class="form-group">
          <label>عدد المبيعات</label>
          <input type="number" formControlName="numOfSale" min="0" />
        </div>

        <div class="switch-card">
          <div class="switch-info">
            <div class="switch-icon">✅</div>
            <div>
              <label class="switch-label">الحالة</label>
              <small>تفعيل أو إيقاف ظهور المنتج</small>
            </div>
          </div>

          <label class="switch modern-switch">
            <input type="checkbox" formControlName="status" />
            <span></span>
          </label>
        </div>

        <div class="switch-card">
          <div class="switch-info">
            <div class="switch-icon">🔥</div>
            <div>
              <label class="switch-label">الأفضل مبيعًا</label>
              <small>تمييز المنتج ضمن المنتجات الأكثر مبيعًا</small>
            </div>
          </div>

          <label class="switch modern-switch">
            <input type="checkbox" formControlName="isBestSeller" />
            <span></span>
          </label>
        </div>
 @if (allowToNegativeStock == true) {       
        <div class="switch-card">
          <div class="switch-info">
            <div class="switch-icon">-</div>
            <div>
              <label class="switch-label">السماح بسالب المخزون</label>
              <small>السماح بسالب المخزون</small>
            </div>
          </div>

          <label class="switch modern-switch">
            <input type="checkbox" formControlName="isNegativeStock" />
            <span></span>
          </label>
        </div>
      }
      </div>

      <div class="grid three">
        <div class="form-group" [class.invalid]="isFieldInvalid('storeId')">
          <label>المتجر *</label>

          <select formControlName="storeId">
            <option *ngFor="let store of stores" [ngValue]="store.id">
              {{ store.name }}
            </option>
          </select>

          <small class="error" *ngIf="isFieldInvalid('storeId')">
            {{ getFieldError('storeId') }}
          </small>
        </div>
      </div>

      <div class="language-box">
        <h3>الاسم والوصف</h3>

        <div class="grid two">
          <div class="form-group" [class.invalid]="isFieldInvalid('arName')">
            <label>اسم المنتج بالعربي *</label>

            <input type="text" formControlName="arName" placeholder="مثال: حلواني مربى فراولة" />

            <small class="error" *ngIf="isFieldInvalid('arName')">
              {{ getFieldError('arName') }}
            </small>
          </div>

          <div class="form-group" [class.invalid]="isFieldInvalid('enName')">
            <label>Product Name English *</label>

            <input type="text" formControlName="enName" placeholder="Example: Strawberry Jam" />

            <small class="error" *ngIf="isFieldInvalid('enName')">
              {{ getFieldError('enName') }}
            </small>
          </div>
        </div>

        <div class="grid two">
          <div class="form-group">
            <label>الوصف بالعربي</label>
            <textarea formControlName="arDescription" rows="4"></textarea>
          </div>

          <div class="form-group">
            <label>Description English</label>
            <textarea formControlName="enDescription" rows="4"></textarea>
          </div>
        </div>
      </div>

      <div class="flags">
        <label>
          <input type="checkbox" formControlName="published" />
          منشور
        </label>

        <label>
          <input type="checkbox" formControlName="approved" />
          معتمد
        </label>

        <label>
          <input type="checkbox" formControlName="isFeatured" />
          منتج مميز
        </label>

        <label>
          <input type="checkbox" formControlName="isTodaysDeal" />
          عرض اليوم
        </label>
      </div>
    </section>

    <!-- PRICE -->
    <section *ngIf="activeTab === 'price'" class="tab-body">
      <div class="section-title">
        <h2>السعر والمخزون</h2>
        <p>تعديل الأسعار، SKU، الباركود، وكميات المخزون.</p>
      </div>

      <div class="grid two">
        <div class="form-group" [class.invalid]="isFieldInvalid('purchasePrice')">
          <label>سعر الشراء *</label>

          <input type="number" formControlName="purchasePrice" min="0" step="0.01" />

          <small class="error" *ngIf="isFieldInvalid('purchasePrice')">
            {{ getFieldError('purchasePrice') }}
          </small>
        </div>

        <div class="form-group" [class.invalid]="isFieldInvalid('sellingPrice')">
          <label>سعر البيع *</label>

          <input type="number" readonly formControlName="sellingPrice" min="0" step="0.01" />

          <small class="error" *ngIf="isFieldInvalid('sellingPrice')">
            {{ getFieldError('sellingPrice') }}
          </small>
        </div>
      </div>

      <div class="grid two">
        <div class="form-group" [class.invalid]="isFieldInvalid('sku')">
          <label>SKU *</label>

          <input type="text" formControlName="sku" />

          <small class="error" *ngIf="isFieldInvalid('sku')">
            {{ getFieldError('sku') }}
          </small>
        </div>

        <div class="form-group" [class.invalid]="isFieldInvalid('barcode')">
          <label>Barcode *</label>

          <input type="text" formControlName="barcode" />

          <small class="error" *ngIf="isFieldInvalid('barcode')">
            {{ getFieldError('barcode') }}
          </small>
        </div>
      </div>

      <div class="grid three">
        <div class="form-group" [class.invalid]="isFieldInvalid('unitId')">
          <label>الوحدة *</label>

          <select formControlName="unitId">
            <option [ngValue]="null">اختر الوحدة</option>
            <option *ngFor="let unit of units" [ngValue]="unit.id.toString()">
              {{ unit.name }}
            </option>
          </select>

          <small class="error" *ngIf="isFieldInvalid('unitId')">
            {{ getFieldError('unitId') }}
          </small>
        </div>

        <div class="form-group" [class.invalid]="isFieldInvalid('unitFactor')">
          <label>Unit Factor *</label>

          <input type="text" formControlName="unitFactor" />

          <small class="error" *ngIf="isFieldInvalid('unitFactor')">
            {{ getFieldError('unitFactor') }}
          </small>
        </div>

        <div class="form-group" [class.invalid]="isFieldInvalid('barcodeType')">
          <label>Barcode Type *</label>

          <input type="text" formControlName="barcodeType" />

          <small class="error" *ngIf="isFieldInvalid('barcodeType')">
            {{ getFieldError('barcodeType') }}
          </small>
        </div>
      </div>

      <div class="grid three">
        <div class="form-group" [class.invalid]="isFieldInvalid('discount')">
          <label>الخصم</label>

          <div class="percent-input">
            <input type="text" formControlName="discount" placeholder="0" min="0" max="100" />
            <span>%</span>
          </div>

          <small class="error" *ngIf="isFieldInvalid('discount')">
            {{ getFieldError('discount') }}
          </small>
        </div>

        <div class="form-group" [class.invalid]="isFieldInvalid('maxPurchaseQty')">
          <label>أقصي كمية شراء *</label>

          <input type="number" formControlName="maxPurchaseQty" min="0" />

          <small class="error" *ngIf="isFieldInvalid('maxPurchaseQty')">
            {{ getFieldError('maxPurchaseQty') }}
          </small>
        </div>

        <div class="form-group" [class.invalid]="isFieldInvalid('minPurchaseQty')">
          <label>أقل كمية شراء *</label>

          <input type="number" formControlName="minPurchaseQty" min="1" />

          <small class="error" *ngIf="isFieldInvalid('minPurchaseQty')">
            {{ getFieldError('minPurchaseQty') }}
          </small>
        </div>
      </div>

      <div class="grid two">
        <div class="form-group" [class.invalid]="isFieldInvalid('weightKg')">
          <label>الوزن بالكيلو</label>

          <input type="number" formControlName="weightKg" min="0" step="0.125" />

          <small class="error" *ngIf="isFieldInvalid('weightKg')">
            {{ getFieldError('weightKg') }}
          </small>
        </div>
      </div>

      <div class="stock-section">
        <div class="stock-header">
          <div>
            <h3>المخزون</h3>
            <p>كل متجر يظهر مرة واحدة فقط.</p>
          </div>

          <button type="button" class="btn add" (click)="addStock()">
            + إضافة مخزن
          </button>
        </div>

        <div formArrayName="stocks" class="stock-list">
          <div class="stock-row" *ngFor="let stock of stocks.controls; let i = index" [formGroupName]="i">
            <div class="form-group">
              <label>المتجر</label>

              <select formControlName="storeId">
                <option *ngFor="let store of stores" [ngValue]="store.id">
                  {{ store.name }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label>الكمية</label>
              <input type="number" formControlName="quantity" min="0" />
            </div>

            <div class="form-group">
              <label>السعر</label>
              <input type="number" formControlName="price" min="0" step="0.01" />
            </div>

            <button type="button" class="btn danger" (click)="removeStock(i)" [disabled]="stocks.length <= 1">
              حذف
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- MEDIA -->
    <section *ngIf="activeTab === 'media'" class="tab-body">
      <div class="section-title">
        <h2>الوسائط والتهيئة</h2>
        <p>تعديل الـ Variant، slug، ومعرفات الصور المحفوظة.</p>
      </div>

      <div class="grid two">
        <div class="form-group">
          <label>Variant</label>

          <select formControlName="variantId">
            <option [ngValue]="null">اختر المتغير</option>
            <option *ngFor="let variant of variants" [ngValue]="variant.id">
              {{ variant.name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>Slug</label>
          <input type="text" formControlName="slug" placeholder="product-name" />
        </div>
        <div class="form-group">
          <label>Video Url</label>
          <input type="text" formControlName="video_link" placeholder="Video-Url" />
        </div>
      </div>

      <div class="form-group photos-picker">
        <label>صور المنتج</label>

        <div class="selected-photos-box">
          <div class="selected-photos" *ngIf="selectedPhotos.length > 0; else noPhotos">
            <div class="selected-photo-card" *ngFor="let photo of selectedPhotos">
              <img [src]="photo.url | ImageUrlPipe" alt="product photo" appImageFallback />

              <button type="button" class="remove-photo-btn" (click)="removeSelectedPhoto(photo)">
                ×
              </button>
            </div>
          </div>

          <ng-template #noPhotos>
            <div class="empty-photos">لم يتم اختيار صور بعد</div>
          </ng-template>

          <button type="button" class="btn-open-gallery" (click)="openGalleryModal()">
            اختيار من الجالري
          </button>
        </div>

        <input type="hidden" formControlName="photosIdsText" />
      </div>

      <div class="gallery-modal-backdrop" *ngIf="isGalleryModalOpen">
        <div class="gallery-modal">
          <div class="gallery-modal-header">
            <h3>اختيار الصور</h3>

            <button type="button" class="close-modal-btn" (click)="closeGalleryModal()">
              ×
            </button>
          </div>

          <div class="gallery-modal-body">
            <app-gallery-picker [selectedImages]="selectedPhotos"
              (selectedImagesChange)="onGalleryImagesChange($event)"></app-gallery-picker>
          </div>

          <div class="gallery-modal-footer">
            <button type="button" class="btn-cancel" (click)="closeGalleryModal()">
              إغلاق
            </button>
          </div>
        </div>
      </div>
    </section>

    <div class="form-footer">
      <div>
        <button type="button" class="btn ghost" (click)="previousTab()" [disabled]="isFirstTab() || isSaving">
          السابق
        </button>

        <button type="button" class="btn ghost" (click)="nextTab()" [disabled]="isLastTab() || isSaving">
          التالي
        </button>
      </div>

      <div>
        <button type="button" class="btn light" (click)="onCancel()" [disabled]="isSaving">
          إلغاء
        </button>

        <button type="button" class="btn primary" (click)="onSubmit()" [disabled]="isSaving">
          {{ isSaving ? 'جاري الحفظ...' : 'حفظ التعديلات' }}
        </button>
      </div>
    </div>
  </form>
</div>